"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationListMaxHeight = void 0;
const constants_1 = require("./constants");
const getNotificationListMaxHeight = (isFooterEnabled) => isFooterEnabled
    ? constants_1.APP_BAR_NOTIFICATION_MAX_HEIGHT_POPOVER - constants_1.APP_BAR_NOTIFICATION_FOOTER_HEIGHT
    : constants_1.APP_BAR_NOTIFICATION_MAX_HEIGHT_POPOVER;
exports.getNotificationListMaxHeight = getNotificationListMaxHeight;
//# sourceMappingURL=getNotificationListMaxHeight.js.map